export default import.meta.ROLLUP_FILE_URL_EsoE3ahAy_$70CHcSjffhg